export const ORGANIZATIONAL_STATUSES = {
  EMPLOYED: 'employed',
  JOINING: 'joining',
  LEAVING: 'leaving',
  RESIGNED: 'resigned',
  CANCELLED: 'cancelled'
};

export const getStatusColor = (status) => {
  switch (status) {
    case ORGANIZATIONAL_STATUSES.EMPLOYED:
      return '#E6F4EA'; // Light green
    case ORGANIZATIONAL_STATUSES.JOINING:
      return '#E8F0FE'; // Light blue
    case ORGANIZATIONAL_STATUSES.LEAVING:
      return '#FEF3C7'; // Light yellow
    case ORGANIZATIONAL_STATUSES.RESIGNED:
      return '#F3F4F6'; // Light gray
    case ORGANIZATIONAL_STATUSES.CANCELLED:
      return '#FEE2E2'; // Light red
    default:
      return '#F3F4F6';
  }
};

export const getStatusTextColor = (status) => {
  switch (status) {
    case ORGANIZATIONAL_STATUSES.EMPLOYED:
      return '#1E8E3E'; // Green
    case ORGANIZATIONAL_STATUSES.JOINING:
      return '#1967D2'; // Blue
    case ORGANIZATIONAL_STATUSES.LEAVING:
      return '#D97706'; // Amber
    case ORGANIZATIONAL_STATUSES.RESIGNED:
      return '#6B7280'; // Gray
    case ORGANIZATIONAL_STATUSES.CANCELLED:
      return '#DC2626'; // Red
    default:
      return '#6B7280';
  }
};

export const getStatusText = (status) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
}; 